export interface IQuestionnaires {
    id: number;
    name: string;
    shortName: string;
    showInMedicalOverview: boolean;
}

export class Questionnaires implements IQuestionnaires {
    id: number;
    name: string;
    shortName: string;
    showInMedicalOverview: boolean;

    constructor(data: IQuestionnaires) {
        this.id = data.id;
        this.name = data.name;
        this.shortName = data.shortName;
        this.showInMedicalOverview = data.showInMedicalOverview;
    }
}

export interface IQuestionnairesPayload {
    id?: number;
    nameFr: string;
    nameEn: string;
    shortNameEn: string;
    shortNameFr: string;
    rawJson: string;
    themeJson?: string;
    showInMedicalOverview: boolean;
    isPhysicalExamination: boolean;
    isMedicalHistory: boolean;
    isCounsellingNote: boolean;
    scoringMode: number;
    questionScores: IQuestionScore[];
    categoryConfigs?: ICategoryConfig[];
}

export class QuestionnairesJson implements IQuestionnairesPayload {
    nameFr: string;
    nameEn: string;
    shortNameEn: string;
    shortNameFr: string;
    rawJson: string;
    themeJson?: string;
    showInMedicalOverview: boolean;
    isPhysicalExamination: boolean;
    isMedicalHistory: boolean;
    isCounsellingNote: boolean;
    scoringMode: number;
    questionScores: IQuestionScore[];
    categoryConfigs?: ICategoryConfig[];

    constructor(data: QuestionnairesJson) {
        this.nameFr = data.nameFr;
        this.nameEn = data.nameEn;
        this.shortNameEn = data.shortNameEn;
        this.shortNameFr = data.shortNameFr;
        this.rawJson = data.rawJson;
        this.themeJson = data.themeJson;
        this.showInMedicalOverview = data.showInMedicalOverview;
        this.isPhysicalExamination = data.isPhysicalExamination ?? false;
        this.isMedicalHistory = data.isMedicalHistory ?? false;
        this.isCounsellingNote = data.isCounsellingNote ?? false;
        this.scoringMode = data.scoringMode || 1; // Default to Average
        this.questionScores = data.questionScores;
        this.categoryConfigs = data.categoryConfigs;
    }
}

export interface IQuestionScore {
    id?: number;
    questionName: string;
    categoryFr: string;
    categoryEn: string;
    scoring: string;
}

export interface ICategoryConfig {
    id?: number;
    categoryFr: string;
    categoryEn: string;
    calculatedValueName: string;
}

export interface ISurveyPreviewValidationPayload {
    rawJson: string;
    answersJson: string;
    calculatedValues: Record<string, any>;
}

export interface IReprocessLogEntry {
    taskID: number;
    level: string; // "info", "warning", "error"
    message: string;
    details: string;
}

export interface IQuestionnaireReprocessResult {
    totalTasks: number;
    successfulTasks: number;
    failedTasks: number;
    isDryRun: boolean;
    logs: IReprocessLogEntry[];
}
